import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=3e17d9be&"
import script from "./DiscoverPage.vue?vue&type=script&lang=js&"
export * from "./DiscoverPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverPage.vue?vue&type=style&index=0&id=3e17d9be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports